<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-if="isFinanceMode">财务管理</el-breadcrumb-item>
        <el-breadcrumb-item v-else to="/customer/ajx/table">客户管理({{customer.name}})</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="项目ID"
                        prop="id">
            <el-input placeholder="请输入项目ID"
                      clearable
                      v-model="search.id"></el-input>
          </el-form-item>
          <el-form-item label="项目名称"
                        prop="keyword">
            <el-input placeholder="请输入名称/编号模糊搜索"
                      clearable
                      v-model="search.keyword"></el-input>
          </el-form-item>
          <el-form-item label="开始时间"
                        prop="starttime">
            <el-date-picker
                v-model="search.starttime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max"
                clearable>
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     v-if="!isFinanceMode"
                     @click="onExportSearch()">搜索结果导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="项目ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="number"
                         label="项目编号"
                         min-width="90"></el-table-column>
        <el-table-column prop="name"
                         label="项目名称"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="status"
                         :formatter="statusFormat"
                         label="状态"></el-table-column>
        <el-table-column prop="total_budget"
                         label="项目预算(元)"></el-table-column>
        <el-table-column prop="projectcost"
                         label="项目成本(元)">
          <template slot-scope="scope">
            <span>{{scope.row.projectcost | toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="predict_others_cost"
                         label="项目其他预算（元）"></el-table-column>
        <el-table-column prop="actual_other_cost"
                         label="实际其他成本（元）">
          <template slot-scope="scope">
            <span>{{scope.row.actual_other_cost | toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="starttime"
                         :formatter="dateFormat"
                         label="开始时间"></el-table-column>
        <el-table-column prop="endtime"
                         :formatter="dateFormat"
                         label="结束时间"></el-table-column>
        <el-table-column prop="createtime"
                         :formatter="dateFormat"
                         label="创建时间"></el-table-column>
        <el-table-column prop="updatetime"
                         :formatter="dateFormat"
                         label="最后更新时间"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <button-gutter>
              <template v-if="scope.row.status * 1 !== statusEnum.CLOSE">
                <el-button type="danger"
                           size="mini"
                           v-if="scope.row.status * 1 === statusEnum.OPEN"
                           @click="updateStatus(scope.row.id)">提交审核
                </el-button>
                <template v-if="scope.row.status * 1 === statusEnum.REVIEW">
                  <el-button type="danger"
                             size="mini"
                             @click="updateStatus(scope.row.id, statusEnum.ACHIEVEMENT)">确认
                  </el-button>
                  <el-button type="danger"
                             size="mini"
                             @click="updateStatus(scope.row.id, statusEnum.OPEN)">驳回
                  </el-button>
                </template>
                <el-button type="danger"
                           size="mini"
                           v-if="scope.row.status * 1 === statusEnum.ACHIEVEMENT"
                           @click="onCloseProject(scope.row)">关闭项目
                </el-button>
                <el-button type="success"
                           size="mini"
                           @click="$refs.updateBudgetDialog.open(scope.row.id)">预算调整
                </el-button>
                <router-link :to="`/customer-project/budget/table/${scope.row.customerid}/${scope.row.id}`">
                  <el-button type="primary"
                             size="mini">预算调整历史
                  </el-button>
                </router-link>
                <router-link v-if="[30, 40].includes(Number(scope.row.status))" :to="`/customer-project/usebudget/detail/${scope.row.customerid}/${scope.row.id}`">
                  <el-button type="primary"
                            size="mini">预算使用情况
                  </el-button>
              </router-link>
              </template>
            </button-gutter>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <update-budget-dialog ref="updateBudgetDialog"
                          @submitted="onRefresh">
    </update-budget-dialog>
  </div>
</template>

<script>
import { searchRules } from '../customer-project.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'
import UpdateBudgetDialog from '@views/customer-project/components/AjxUpdateBudgetDialog'

export default {
  mixins: [table, dateTimePicker],
  components: {UpdateBudgetDialog},
  data () {
    return {
      showUpdateBudgetDialog: false,
      customerId: this.$route.params.id,
      updateBudget: {
        id: null,
        desc: null,
        budget: null,
      },
      customer: {
        id: this.$route.params.id,
        name: null
      },
      searchRules,
      search: {
        id: null,
        keyword: null,
        starttime: [],
        status: [20, 30, 40],
        is_ajx: true,
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      customerDetail: state => state.customer.selectedCustomerDetail,
      projectStatusMap: state => state.customerProjectcost.options.status,
      statusEnum: state => state.customerProjectcost.statusEnum,
      options: state => state.project.options,
    }),
    isFinanceMode () {
      return _.startsWith(this.$route.path, '/finance/ajx')
    }
  },

  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      if (!this.isFinanceMode) {
        this.setCustomer()
        params.customerid = this.customerId
      }
      return request.page('getProjectTable', params)
    },
    exportProjectTable (params) {
      if (!this.isFinanceMode) {
        params.customerid = this.customerId
      }
      return request.page('exportProjectTable', params)
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        total: this.pagination.total,
        request: this.exportProjectTable,
        requestParams: this.search,
        type: 'array',
        getResponseData (data) {
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        }
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportProjectTable', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    dateFormat (row, column, cellValue, index) {
      return filter.formatDate(cellValue * 1000)
    },
    statusFormat (row, column, cellValue, index) {
      const projectStatusMap = this.projectStatusMap
      for (let i in projectStatusMap) {
        if (projectStatusMap.hasOwnProperty(i) && projectStatusMap[i].value === cellValue * 1) {
          return projectStatusMap[i].label
        }
      }
    },
    setCustomer () {
      if (this.customerDetail) {
        this.customer.name = this.customerDetail.name
        return
      }
      request.common('getCustomerDetail', {id: this.$route.params.id}).then(({data}) => {
        this.customer.name = data.name
      })
    },
    onCloseProject (row) {
      const name = (row && row.name) ? row.name : ''
      const tip = name
        ? `确认关闭项目「${name}」？`
        : '确认关闭该项目？'
      this.$confirm(tip, '提示', {type: 'warning'}).then(() => {
        this.updateStatus(row.id, null)
      }).catch(() => {})
    },
    updateStatus (id, status) {
      request.common('updateProjectStatus', {id, status}).then(_ => {
        this.$message.success('设置成功')
        this.onRefresh()
      })
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/views/customer-project/pages/AjxProjectTable.vue